export const TASK_MANAGER_STATUS = {
  OFFLINE: 'offline',
  ONLINE: 'online',
};
